import React, { useState, useEffect } from "react";
import { GetDataCreate } from "./Components/Services";
import Loading from "../../../Common/Components/Loading";
import FormSteps from "../../../Common/Components/StepForm";
import { Helmet } from "react-helmet";

function CreateBySteps() {
  const [data_create, setDataCreate] = useState({
    Manegers: "",
  });
  const [loading, setLoading] = useState(true);

  const form = {
    route: "/item/new_item",
    firstStep: "step_1",
    lastStep: "step_5",
    titr: "ایجاد مجموعه",
    lastBtn: "ایجاد مجموعه",
    initialeState: { images_alt: [] },
    steps: [
      "اطلاعات مدیر مجموعه",
      "جزییات مجموعه",
      "امکانات و تگ های مجموعه",
      "اطلاعات جغرافیایی",
      "تصاویر مجموعه",
    ],
    step_1: {
      title: "اطلاعات مدیر مجموعه",
      form: [
        {
          name: " نام مدیر مجموعه",
          key: "fullname",
          type: "input",
          col: "col-md-6",
          nested: "manager_info",
        },

        {
          name: "کد ملی",
          key: "national_code",
          type: "input",
          col: "col-md-6",

          nested: "manager_info",
        },
        {
          name: "شماره موبایل",
          key: "mobile",
          type: "input",
          col: "col-md-6",
          nested: "manager_info",
        },
        {
          name: "شماره ثبت",
          key: "registration_number",
          type: "input",
          col: "col-md-6",
          check: 3,
          method: {
            route: "/item/check_newitem",
          },
        },
        {
          name: "جنسیت",
          key: "gender",
          type: "select",
          col: "col-md-6",
          nested: "manager_info",
          options: [
            {
              name: "آقا",
              id: "man",
            },
            {
              name: "خانم",
              id: "woman",
            },
          ],
        },
      ],
    },
    step_2: {
      title: "جزییات مجموعه",
      form: [
        {
          name: "عنوان مجموعه",
          key: "name",
          type: "input",
          col: "col-md-4",
        },
        {
          name: "قیمت رزرو",
          key: "header_price",
          type: "input",
          col: "col-md-4",
        },
        {
          name: "دسته مجموعه",
          key: "category_id",
          type: "select",
          col: "col-md-4",
          options: !loading && data_create && data_create.Categoreis,
        },

        {
          name: "شماره ثابت",
          key: "phone",
          nested: "details",
          type: "input",
          col: "col-md-3",
          noNeed: true,
        },
        {
          name: "شماره همراه",
          key: "mobile",
          nested: "details",
          type: "input",
          col: "col-md-3",
        },

        {
          name: "جنسیت ورزشکاران",
          key: "gender",
          type: "select",
          col: "col-md-6",
          options: [
            {
              name: "آقایان",
              id: "men",
            },
            {
              name: "بانوان",
              id: "women",
            },
            {
              name: "هردو",
              id: "both",
            },
          ],
        },
        {
          name: <span>توضیحات <span className="text-danger">ضروری</span> مجموعه</span>,
          key: "necessary_description",
          type: "editor",
          col: "col-md-12",
        },
        {
          name: "توضیحات مجموعه",
          key: "description",
          type: "editor",
          col: "col-md-12",
        },
        {
          name: "قوانین و مقررات ",
          key: "rules",
          type: "editor",
          col: "col-md-12",
        },
        {
          name: "کد اسکیما",
          key: "seoSchema",
          type: "textArea",
          col: "col-md-6",
          nested: "seo",
          noNeed: true
        },
        {
          name: "توضیحات کلیدی سئو",
          key: "seoDescription",
          type: "textArea",
          col: "col-md-6",
          nested: "seo",
        },
      ],
    },
    step_3: {
      title: "امکانات و تگ های مجموعه",

      form: [
        {
          name: "امکانات مجموعه",
          key: "options",
          type: "selectTable",
          col: "col-md-6",
          options: !loading && data_create && data_create.Options,
        },
        {
          name: "تگ های مجموعه",
          key: "tag_id",
          type: "selectTable",
          col: "col-md-6",
          options: !loading && data_create && data_create.Tags,
        },
      ],
    },
    step_4: {
      title: "اطلاعات جغرافیایی",
      form: [
        {
          name: "استان شهرستان منطقه",
          type: "region",
          col: "col-md-12",
          key: "region_id",
        },
        {
          name: "موقعیت جغرافیایی",
          key: "location",
          type: "input",
          col: "col-md-3",
        },
        {
          name: "آدرس کامل",
          key: "address",
          type: "input",
          col: "col-md-9",
        },
      ],
    },
    step_5: {
      title: "تصاویر مجموعه",
      form: [
        {
          name: "تصویر شاخص (لطفا فقط یک عکس انتخاب کنید)",
          type: "file",
          key: "header_image",
          accept: "image/png, image/jpeg",
          col: "col-md-12",
        },
        {
          name: "تصاویر مجموعه",
          type: "file",
          key: "images",
          accept: "image/png, image/jpeg",
          col: "col-md-12",
          alt: true,
        },
      ],
    },
  };

  useEffect(() => {
    setLoading(true);
    GetDataCreate().then(res => {
      if (res) {
        setDataCreate(res);
      }
      setLoading(false);
    });
  }, []);
  return (
    <>
      <Helmet>
        <title>نیکوتن | ثبت مجموعه</title>
      </Helmet>
      {loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <FormSteps elements={form} />
      )}
    </>
  );
}

export default CreateBySteps;
